// src/context/AppContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    const savedLang = localStorage.getItem('language');
    return savedLang || 'zh';
  });

  const [currentUser, setCurrentUserState] = useState(null);

  // 初始化时从 localStorage 加载用户信息
  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setCurrentUserState(user);
        console.log('✅ 从 localStorage 加载用户:', user);
      } catch (err) {
        console.error('❌ 解析用户信息失败:', err);
        localStorage.removeItem('user');
      }
    }
  }, []);

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem('language', lang);
  };

  // 设置用户时同步到 localStorage
  const setCurrentUser = (user) => {
    setCurrentUserState(user);
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }
  };

  // 便捷判断：是否是总店
  const isHeadquarters = currentUser?.store_type === 'headquarters';

  // 登出
  const logout = () => {
    setCurrentUser(null);
  };

  const value = {
    language,
    currentUser,
    isHeadquarters,
    setLanguage,
    setCurrentUser,
    logout
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};